import { KonsoleUser } from 'app/types/users/konsole'

/** Name of the manager role. */
export const ROLE_MANAGER = 'Gestionnaire'

/** Determines the value of the hasChoiceManager depending on the given user. */
export const getHasChoiceManager = (user: KonsoleUser) => {
    if (user.is_superuser || user.is_staff || user.profil.client.length > 1) {
        return true
    }

    return false
}
